<template>
	<v-btn class="mr-4 mb-4 d-sm-none" fab dark color="accent" :to="{name: 'NewMemory'}" style="position:fixed; bottom:0; right:0;">
		<v-icon dark large>mdi-plus</v-icon>
	</v-btn>
</template>
<script>
export default {
	name: 'RNewButton'
}
</script>